import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {TextField, Tooltip} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Chip from "@material-ui/core/Chip";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {errorHandler} from "../../Utils/errorHandler";
import SortableItem from "../../../../ReactSelectMaterial/Sortable/SortableItem";
import SortableContainer from "../../../../ReactSelectMaterial/Sortable/SortableContainer";
import InputAdornment from "@material-ui/core/InputAdornment";
import {useSelector} from "react-redux";
import {multiLanguageValue, shortcutCombinationMatcher} from "../../../../../Components/JsonScreen/Utils/lib";
import {useDeepCompareCallback} from "use-deep-compare";
import {useEventListener} from "../../../../../Hooks/useEventListener";

const useStyles = makeStyles(() => ({
    textFieldRoot: {
        '& .MuiInput-underline:before': {
            borderBottomColor: 'rgba(0,0,0,0.22)', // Semi-transparent underline
        },
    },
    inputRoot: {
        '&[class*="MuiInput-root"]': {
            paddingRight: 0,
            '& $input': {
                padding: '4px 4px',
            },
        },
        '&[class*=MuiAutocomplete-inputRoot]': {
            paddingRight: '0px'
        },
        '&[class*="MuiOutlinedInput-root"]': {
            padding: '1px',
            paddingRight: '3px !important',
            '& $input': {
                padding: '2px 4px !important',
            },
        },
    },
    paper: {
        display: 'none'
    },
    clearIndicator: {
        display: 'none',
    },
    popupIndicator: {display: 'none'},
    tag: {
        height: '24px'
    },
}));

const ArrayField = (props) => {
    const {
        fieldValue, type, autofocus, fieldStyles, endDrag, swapItems, onChangeTextField,
        fieldRef, disabled, error, errors, field, filterValue, isMobile, label,
        onBlur, onChange, path, required, loading, isOpen,
        fieldPresentation, placeholder, events, doActions
    } = props;
    const classes = useStyles();
    const userLanguage = useSelector(state => state.app.userLanguage);
    const customStyles = (isMobile || fieldStyles.presentation === 'standard') ? {
            width: '100%',
            marginTop: 4
        } :
        {
            width: '100%',
            margin: fieldStyles.margin,
            paddingTop: fieldStyles.withoutPadding ? 0 : !isMobile && 3,
            paddingLeft: fieldStyles.withoutPadding ? 0 : !isMobile && 2,
        };
    const inputPropsStyles = {
        style: {
            height: fieldStyles.height
        }
    };
    const onKeyDownHandler = useDeepCompareCallback((e) => {
        const onKeydownEvent = events?.find(v => v.event === 'onKeydown')
        if (onKeydownEvent) {
            shortcutCombinationMatcher(e, onKeydownEvent.shortcut, () => {
                doActions(onKeydownEvent.actions, {currentField: {value: fieldValue}})
            })
        }

    }, [events, fieldValue])

    useEventListener('keydown', onKeyDownHandler, fieldRef.current)

    return (
        <SortableContainer>
            <Autocomplete
                value={fieldValue || []}
                options={[]}
                onChange={(event, value) => onChange(value)}
                open={false}
                disabled={disabled}
                multiple
                ref={fieldRef}
                className={"sb-entity-external-field"}
                classes={{
                    inputRoot: classes.inputRoot,
                    clearIndicator: classes.clearIndicator,
                    popupIndicator: classes.popupIndicator,
                    paper: classes.paper,
                    tag: classes.tag,
                }}
                inputValue={filterValue}
                onBlur={onBlur}
                getOptionLabel={option => option.label || ''}
                renderInput={params =>
                    <TextField
                        {...params}
                        required={required && (fieldValue === null || !fieldValue.length)}
                        label={(isMobile || fieldStyles.presentation === 'standard') && multiLanguageValue(label, userLanguage)}
                        placeholder={multiLanguageValue(placeholder, userLanguage)}
                        variant={isMobile ? 'standard' : fieldPresentation}
                        error={error.length > 0}
                        fullWidth={isMobile ? true : fieldStyles.fullWidth}
                        autoFocus={autofocus}
                        autoComplete="off"
                        className={
                            fieldStyles.withoutStyles ?
                                'horizontal-fields-table' :
                                'form-dynamic'
                        }
                        type={type}
                        onChange={onChangeTextField}
                        style={customStyles}
                        name={path}
                        inputProps={{
                            ...params.inputProps,
                            ...inputPropsStyles
                        }}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <InputAdornment position={'end'} style={{
                                    position: 'absolute',
                                    right: 3,
                                    top: '50%'
                                }}>
                                    {loading ? <CircularProgress color="inherit" size={12}/> : null}
                                    <IconButton
                                        style={{padding: 0, left: isMobile ? 0 : -6}}
                                        tabIndex={-1}
                                        disabled={disabled}
                                    >
                                        <ArrowDropDownIcon
                                            style={{
                                                color: disabled ? 'rgba(0, 0, 0, 0.38)' : 'rgba(0, 0, 0, 0.54)',
                                                transform: isOpen === true ? 'rotate(180deg)' : "rotate(0deg)"
                                            }}/>
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />}
                renderTags={(value, getTagProps) =>
                    value.map((tag, index) => {
                        let error = errorHandler(errors, `${path}.${index}`);
                        return (
                            <SortableItem
                                index={index}
                                key={tag.idx}
                                moveCard={swapItems}
                                endDrag={endDrag}
                                element={field}
                            >
                                <Tooltip title={error.length > 0 ? error : ''}>
                                    <Chip
                                        id={`chip_${index}`}
                                        style={{
                                            border: error.length > 0 ? '1px solid red' : 'none'
                                        }}
                                        variant="default"
                                        label={tag.label}
                                        {...getTagProps({index})}
                                        //onDoubleClick={() => handleDoubleClick()}
                                        //onKeyDown={() => onKeyDownChip()}
                                    />
                                </Tooltip>
                            </SortableItem>
                        )
                    })
                }
            />
        </SortableContainer>
    )
};
export default ArrayField

ArrayField.defaultProps = {
    fieldPresentation: 'outlined'
}